import React from "react";
import { useTranslation } from "react-i18next";
import { changedTermGroups } from "./employment-terms";
import type { SavedAmendmentTerms } from "./employment-terms";

const GROUP_CHIPS = [
  { group: "positions", labelKey: "amendment_change_positions" },
  { group: "salary", labelKey: "amendment_change_salary" },
  { group: "hours", labelKey: "amendment_change_hours" },
] as const;

/** One chip for each of position, salary and working hours that the amendment actually changes. */
export default function TermGroupChips({ amendment }: { amendment: SavedAmendmentTerms }) {
  const { t } = useTranslation();
  const changed = changedTermGroups(amendment);
  return (
    <>
      {GROUP_CHIPS.filter(({ group }) => changed[group]).map(({ group, labelKey }) => (
        <span
          key={group}
          className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-indigo-50 text-indigo-800"
        >
          {t(labelKey)}
        </span>
      ))}
    </>
  );
}
